import { Alert, AlertDescription, AlertTitle } from '@/shared/components/shadcn/alert';
import { Button } from '@/shared/components/shadcn/button';
import { Skeleton } from '@/shared/components/shadcn/skeleton';

type ScrapingErrorStateProps = {
  onRetry: () => void;
};

export function ScrapingTableLoadingState() {
  return (
    <div className="flex flex-col gap-3 py-4">
      {Array.from({ length: 5 }).map((_, index) => (
        <Skeleton key={index} className="h-12 w-full" />
      ))}
    </div>
  );
}

export function ScrapingEmptyState() {
  return (
    <div className="border-border flex min-h-48 flex-col items-center justify-center gap-2 rounded-lg border border-dashed p-8 text-center">
      <p className="text-sm font-medium">No scraping intents yet.</p>
      <p className="text-muted-foreground max-w-md text-sm">
        Try another tab or refresh after a scraping request has been created.
      </p>
    </div>
  );
}

export function ScrapingErrorState({ onRetry }: ScrapingErrorStateProps) {
  return (
    <Alert variant="destructive">
      <AlertTitle>Unable to load scraping data</AlertTitle>
      <AlertDescription className="flex flex-col items-start gap-3">
        <span>Refresh the section after checking the internal API connection.</span>
        <Button variant="outline" size="sm" onClick={onRetry}>
          Retry
        </Button>
      </AlertDescription>
    </Alert>
  );
}
